import script from "./OrderSearchDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderSearchDetail.vue?vue&type=script&setup=true&lang=ts"

import "./OrderSearchDetail.vue?vue&type=style&index=0&id=489b2dc0&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-489b2dc0"]])

export default __exports__